import { useCallback, useEffect, useState } from "react";
import { profilesApi } from "../api/endpoints/profiles";

/**
 * Loads a single child profile by id; re-fetches when the id changes.
 */
export function useProfile(id) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(Boolean(id));
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        if (!id) {
            setData(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const result = await profilesApi.get(id);
            setData(result);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        load();
    }, [load]);

    return { data, loading, error, refetch: load };
}
